export const GET_INFO = 'GET_INFO'

export const CHANGE_INTENTION = 'CHANGE_INTENTION'

export const CHANGE_CITY = 'CHANGE_CITY'

export const CHANGE_CURRENT_INDEX = 'CHANGE_CURRENT_INDEX'

export const IS_MEMBERSHIP = 'IS_MEMBERSHIP'

export const GET_MEMBERSHIP = 'MEMBERSHIP'

export const GET_BUY_MEMBER_DATA = 'GET_BUY_MEMBER_DATA'

export const GET_UDESK_ONLINE_URL = 'GET_UDESK_ONLINE_URL'

export const PUBLIC_KEY = 'PUBLIC_KEY'

export const PRIVATE_KEY = 'PRIVATE_KEY'

export const USER_TOKEN = 'USER_TOKEN'

export const IS_LOGIN = 'IS_LOGIN'

export const IS_USER = 'IS_USER'

export const GET_USER_IDENTIFY = 'GET_USER_IDENTIFY'

export const SET_PURCHASE_RECORD_DATA = 'SET_PURCHASE_RECORD_DATA'

export const SET_COUNTDOWN_STATE = 'SET_COUNTDOWN_STATE'
